























































































import {Vue, Prop, Watch, Component} from 'vue-property-decorator';

const maxLevel = 90;

@Component
export default class Cup extends Vue {
    @Prop({ default: 0 })
  progress!: number;
    
    @Watch('progress')
    onProgressChanged() {
        window.requestAnimationFrame(this.animationStep);
    }

    private smoothProgress: number = 0;

    get fillLevel() :string  {
        return (this.smoothProgress * maxLevel).toString() + '%';
    }

    animationStep() {
        if(Math.abs(this.progress - this.smoothProgress) < .001)
             return; 
        
        this.smoothProgress = this.lerp(this.smoothProgress, this.progress, 0.05);

        window.requestAnimationFrame(this.animationStep);
    }

    lerp(from: number, to: number, step: number) {
        return (1 - step) * from + step * to;
    }
    
}
